import { render, staticRenderFns } from "./MenuStock.vue?vue&type=template&id=2f5da880&scoped=true&"
import script from "./MenuStock.vue?vue&type=script&lang=js&"
export * from "./MenuStock.vue?vue&type=script&lang=js&"
import style0 from "./MenuStock.vue?vue&type=style&index=0&id=2f5da880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5da880",
  null
  
)

export default component.exports